import { Box, Button, Stack, Title } from "@mantine/core";
import { IconQrcode } from "@tabler/icons-react";
import { useRef } from "react";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import { Board } from "../../common/boards/board.schema";
import { Event } from "../../common/events/event.schema";
import { getEventLink, getSiteUrl } from "../../common/util";
import PrintFooter from "../print/PrintFooter";

const CheckInQR = ({
  disabled,
  event,
  board,
}: {
  disabled?: boolean;
  event: Event;
  board: Board;
}) => {
  const componentRef = useRef<any>();
  //   const image = event.image || board.image;
  const link = `${getSiteUrl()}${getEventLink(
    board,
    event
  )}?checkin=true&utm_source=qr&utm_medium=print&utm_campaign=checkin`;
  // console.log("link :", link);
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Button
            leftSection={<IconQrcode size={18} />}
            variant="default"
            disabled={disabled}
          >
            Print self check in QR code
          </Button>
        )}
        content={() => componentRef.current || null}
      />
      <Box display="none">
        <Stack
          align="center"
          ref={componentRef}
          py={100}
          gap={60}
          c="black"
          bg="white"
        >
          <Stack align="center">
            <Title ta="center">{board.name}</Title>
            <Title order={2} ta="center">
              {event.name}
            </Title>
            <Title order={3} ta="center">
              Scan to check in for event
            </Title>
          </Stack>
          <QRCode value={link} size={400} />
          <PrintFooter />
        </Stack>
      </Box>
    </>
  );
};
export default CheckInQR;
